"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBarTimer = void 0;

var _luxon = require("luxon");

var _react = _interopRequireDefault(require("react"));

var _ProgressBar = require("../ProgressBar");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** ProgressBarTimer */
var ProgressBarTimer = function ProgressBarTimer(_ref) {
  var currentTime = _ref.currentTime,
      countdownStart = _ref.countdownStart,
      countdownEnd = _ref.countdownEnd,
      _ref$highlight = _ref.highlight,
      highlight = _ref$highlight === void 0 ? "purple100" : _ref$highlight;

  var secondsRemaining = _luxon.DateTime.fromISO(countdownEnd).diff(_luxon.DateTime.fromISO(currentTime.toString()), "seconds").seconds;

  var totalSeconds = _luxon.DateTime.fromISO(countdownEnd).diff(_luxon.DateTime.fromISO(countdownStart), "seconds").seconds;

  var progress = Math.max(0, secondsRemaining * 100 / totalSeconds);
  return /*#__PURE__*/_react.default.createElement(_ProgressBar.ProgressBar, {
    percentComplete: progress,
    highlight: highlight
  });
};

exports.ProgressBarTimer = ProgressBarTimer;
ProgressBarTimer.displayName = "ProgressBarTimer";
//# sourceMappingURL=ProgressBarTimer.js.map